import { BrowserRouter, Routes, Route, useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';

import HomePage from './views/HomePage';
import SignInPage from './views/SignInPage';
import WebstoreLinks from './views/WebstoreLinks';
import OffersAndPromotionsHomePagePromotions from './views/OffersAndPromotionsHomePagePromotions';
import NonValidatedCoupons from './views/NonValidatedCoupons';
import BusinessLocations from './views/BusinessLocations';
import Users from './views/Users';
import UserDetails from './views/UserDetails';
import CouponsPage from './views/CouponsPage';
import CouponDetails from './views/CouponDetails';
import Files from './views/Files';

import './global';

function App() {

  const navigate = useNavigate();

  const [isSignedIn, setIsSignedIn] = useState(false);
  const [activeRoute, setActiveRoute] = useState('/');

  useEffect(() => {
    checkIsSignedIn();
  }, []);

  const checkIsSignedIn = () => {
    const jwt = localStorage.getItem('token');
    setIsSignedIn((jwt != null));
  };

  const handleUpdate = (args) => {
    if (args.updateType == 'checkIsSignedIn') {
      checkIsSignedIn();
    }
    else if (args.updateType == 'navigate') {
      const route = args.route;
      handleNavigate(route);
    }
  };

  const handleNavigate = (route) => {
    if (route == 'home') {
      setActiveRoute('/');
      navigate('/');
    }
    else if (route == '/offers-and-promotions') {
      setActiveRoute('/offers-and-promotions');
      navigate('/offers-and-promotions');
    }
    else if (route == '/nonvalidated-coupons') {
      setActiveRoute('/nonvalidated-coupons');
      navigate('/nonvalidated-coupons');
    }
    else if (route == '/business-locations') {
      setActiveRoute('/business-locations');
      navigate('/business-locations');
    }
    else if (route == '/webstore-links') {
      setActiveRoute('/webstore-links');
      navigate('/webstore-links');
    }
    else if (route == '/users-users') {
      setActiveRoute('/users-users');
      navigate('/users-users');
    }
    else if (route.startsWith('/users-users/')) {
      setActiveRoute('/users-users');
      navigate(route);
    }
    else if (route === '/coupons' || route === '/coupons/lookup') {
      setActiveRoute(route);
      navigate(route);
    }
    else if (route.startsWith('/coupons/lookup/')) {
      setActiveRoute('/coupons/lookup');
      navigate(route);
    }
    else if (route == '/app-files') {
      setActiveRoute('/app-files');
      navigate('/app-files');
    }
    
    
  };

  return (
    <>
      { isSignedIn ? (
        <Routes>
          <Route path='/sign-in' element={<SignInPage />} />
          <Route path='/' element={<HomePage handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
          <Route path='/webstore-links' element={<WebstoreLinks handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
          <Route path='/offers-and-promotions' element={<OffersAndPromotionsHomePagePromotions handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
          <Route path='/nonvalidated-coupons' element={<NonValidatedCoupons handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
          <Route path='/business-locations' element={<BusinessLocations handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
          <Route path='/users-users' element={<Users handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
          <Route path='/users-users/:accountId' element={<UserDetails handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
          <Route path='/coupons' element={<CouponsPage handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
          <Route path='/coupons/lookup' element={<CouponsPage handleUpdate = { handleUpdate } activeRoute = { activeRoute } isLookup />} />
          <Route path='/coupons/lookup/:redemptionId' element={<CouponDetails handleUpdate = { handleUpdate } />} />
          <Route path='/app-files' element={<Files handleUpdate = { handleUpdate } activeRoute = { activeRoute } />} />
        </Routes>
      ) : null }
      { !isSignedIn ? (
        <SignInPage handleUpdate = { (args) => { handleUpdate(args); }} />
      ) : null }
    </>
  );
};

export default App;
